import { partnerDetailsAPI, userAPI, groupAPI } from "../../api's/index";
import { commonApiCall } from "../../utils/index";
var qs = require("qs");

export const getPartnerData = async (params) => {
  const response = await commonApiCall({
    method: "get",
    // url: partnerDetailsAPI,
    url: userAPI + "user-profiles",
    params: params
  });
  return response;
};

export const postPartnerData = async (data) => {
  const response = await commonApiCall({
    method: "post",
    // url: partnerDetailsAPI,
    url: userAPI + "register",
    data: data
  });
  return response;
};

export const editPartnerData = async (data, id) => {
  const response = await commonApiCall({
    method: "put",
    // url: partnerDetailsAPI + id,
    url: userAPI + "user-profiles/" + id + "/",
    data: data
  });
  return response;
};

export const deletePartnerData = async (id) => {
  const response = await commonApiCall({
    method: "delete",
    url: userAPI + "user-profiles/" + id + "/"
  });
  return response;
};

export const getGroupData = async () => {
  const response = await commonApiCall({
    method: "get",
    url: groupAPI,
  });
  return response;
};
